import React from 'react';
import { NavLink } from 'react-router-dom';
import { AppBar, Toolbar, Drawer, List, ListItem, ListItemButton, ListItemText, Divider, Box, Typography,
         Badge, Button, Menu, MenuItem } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CartIcon from '@mui/icons-material/ShoppingCart';
import SearchWidget from 'components/SearchWidget';
import MediaQuery from 'react-responsive';
import { availableLocales, localeTitle } from 'utils/locales';
import { FormattedMessage, injectIntl } from 'react-intl';

const headerStyle = {color: window.HEADER_FONT_COLOUR};
const extraHeaderStyle = {color: window.EXTRA_HEADER_FONT_COLOUR};

export class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      localeMenuOpen: false
    };

    this.handleDrawerOpen = this.handleDrawerOpen.bind(this);
    this.handleDrawerClose = this.handleDrawerClose.bind(this);
    this.handleLocaleMenuClick = this.handleLocaleMenuClick.bind(this);
    this.localeMenuAnchor = null;
  }

  handleDrawerOpen() {
    this.setState({open: true});
  };

  handleDrawerClose() {
    this.setState({open: false});
  };

  handleLocaleMenuClick(event) {
    this.setState({localeMenuOpen: true});
    this.localeMenuAnchor = event.currentTarget;
  };

  handleLocaleChange(locale) {
    this.setState({localeMenuOpen: false});
    this.props.changeLocale(locale);
  };

  render() {
    const { site, cart, locale, navigateTo, intl } = this.props;

    return (
      <React.Fragment>
        {site.header_template == 'double_level' &&
          <div className="extra-header" style={{background: window.EXTRA_HEADER_BACKGROUND_COLOUR}}>
            <div style={{marginLeft: 'auto'}} />
            {!site.disable_balance_check &&
              <NavLink style={{marginRight: '20px'}} to='/balance' className='button-link'>
                {site.balance_icon &&
                  <img src={site.balance_icon} alt="Check Balance" />
                }
                <Button style={extraHeaderStyle}>
                  <FormattedMessage id="navigation.check_balance" defaultMessage="Check Balance"/>
                </Button>
              </NavLink>
            }
            <Box className="cart-badge" onClick={() => navigateTo('/cart')} style={{display: 'contents'}}>
              {site.cart_icon ?
                <img src={site.cart_icon} />
              :
                <CartIcon style={extraHeaderStyle} titleAccess='Cart' />
              }
              <Typography style={extraHeaderStyle} tabIndex="0">
                <FormattedMessage id="navigation.cart" defaultMessage="Basket" />
              </Typography>
              <Badge badgeContent={`${cart.length}`} slotProps={{root: {style: {marginLeft: '10px'}}, badge: {style: {backgroundColor: window.CART_NUMBER_COLOUR, color: 'white'}}}} />
            </Box>
            <MediaQuery minWidth={948}>
              {site.extra_header_url && site.extra_header_url_text &&
                <a href={site.extra_header_url} target='_blank'>
                  <Typography style={extraHeaderStyle}>{site.extra_header_url_text}</Typography>
                </a>
              }
            </MediaQuery>
          </div>
        }
        <AppBar position='relative' color='default' className="appbar" style={{height: '5em', background: window.HEADER_BACKGROUND_COLOUR}}>
          <Toolbar className='toolbar' style={{paddingTop: '10px'}}>
            <MediaQuery maxWidth={948}>
              <MenuIcon onClick={this.handleDrawerOpen} titleAccess='Menu' />
              <div className="logo-container-mobile">
                <NavLink to='/' className='button-link' aria-label="Home">
                  <img src={site.logo} className="header-logo" alt={site.page_title} />
                </NavLink>
              </div>
              {site.search_enabled &&
                <SearchWidget />
              }
              {site.header_template == 'single_level' &&
                <Badge badgeContent={`${cart.length}`} className="cart-badge" color="primary" slotProps={{badge: {style: {backgroundColor: window.CART_NUMBER_COLOUR}}}} onClick={() => navigateTo('/cart')}>
                  <CartIcon titleAccess='Cart' />
                </Badge>
              }
            </MediaQuery>
            <MediaQuery minWidth={948}>
              <NavLink to='/' className='button-link' aria-label="Home">
                <img src={site.logo} className="header-logo" alt={site.page_title} />
              </NavLink>
              {!site.hide_home_button &&
                <NavLink to='/' className='button-link' aria-label="Home">
                  <Button component="div" role="none" tabIndex={-1} style={headerStyle} className="header-button">
                    {site.home_button_text ?
                      site.home_button_text
                    :
                      <FormattedMessage id="navigation.buy_now" defaultMessage="Buy Now" />
                    }
                  </Button>
                </NavLink>
              }
              {site.collection_groups.map((group, index) =>
                <NavLink to={group.direct_collection_link ? `/collections/${group.collection_slug}` : `/categories/${group.slug}`} className='button-link' key={index}>
                  <Button component="div" role="none" tabIndex={-1} style={headerStyle} className="header-button">
                    {group.label}
                  </Button>
                </NavLink>
              )}
              <div style={{marginLeft: 'auto'}} />
              {site.search_enabled &&
                <SearchWidget />
              }
              {site.header_template == 'single_level' &&
                <React.Fragment>
                  {!site.disable_balance_check &&
                    <NavLink to='/balance' className='button-link'>
                      <Button component="div" role="none" tabIndex={-1} style={headerStyle} className="header-button">
                        <FormattedMessage id="navigation.check_balance" defaultMessage="Check Balance" />
                      </Button>
                    </NavLink>
                  }
                  <Badge tabIndex="0" style={{marginLeft: site.disable_balance_check ? 'auto' : '20px'}}
                    slotProps={{badge: {style: {backgroundColor: window.CART_NUMBER_COLOUR}}}}
                    badgeContent={`${cart.length}`} className="cart-badge" color="primary" onClick={() => navigateTo('/cart')}>
                    <CartIcon style={headerStyle} titleAccess='Cart' />
                  </Badge>
                </React.Fragment>
              }
              {site.locales.length > 1 &&
                <div className="locale-menu">
                  <Button aria-haspopup="true" aria-expanded={this.state.localeMenuOpen ? 'true' : undefined} onClick={this.handleLocaleMenuClick} className="header-button button-link">
                    <img className="locale-image" src={`/locales/${locale}.jpg`} alt={locale} />
                    <FormattedMessage id={localeTitle(locale)} defaultMessage={locale}/>
                  </Button>
                  <Menu anchorEl={this.localeMenuAnchor} open={this.state.localeMenuOpen} onClose={() => this.setState({localeMenuOpen: false})}>
                    {availableLocales(site.locales).map(locale => (
                      <MenuItem key={locale.locale} value={locale.locale} onClick={() => this.handleLocaleChange(locale.locale)}>
                        <img className="locale-image" src={`/locales/${locale.locale}.jpg`} alt={locale.locale} />
                        <FormattedMessage id={localeTitle(locale.locale)} defaultMessage={locale.locale}/>
                      </MenuItem>
                    ))}
                  </Menu>
                </div>
              }
            </MediaQuery>
          </Toolbar>
        </AppBar>
        <Drawer variant="temporary"
                open={this.state.open}
                anchor="left"
                ModalProps={{onClose: this.handleDrawerClose}}
                PaperProps={{style: {width: '360px', backgroundColor: window.HEADER_BACKGROUND_COLOUR}}}>
          <List>
            <ListItemButton onClick={this.handleDrawerClose}>
              <img src={site.logo} className="header-logo mobile-logo" style={{marginBottom: '2em'}} alt={site.page_title} />
            </ListItemButton>
            {!site.hide_home_button &&
              <React.Fragment>
                <Divider />
                <NavLink to='/' className='button-link'>
                  <ListItemButton onClick={this.handleDrawerClose}>
                    <ListItemText primary={site.home_button_text ? site.home_button_text : intl.formatMessage({id: "navigation.buy_now", defaultMessage: "Buy Now"})}
                                  primaryTypographyProps={{variant: 'h6', style: headerStyle}} />
                  </ListItemButton>
                </NavLink>
              </React.Fragment>
            }
            <Divider />
            {site.collection_groups.map((group, index) =>
              <React.Fragment key={index}>
                <NavLink to={group.direct_collection_link ? `/collections/${group.collection_slug}` : `/categories/${group.slug}`} className='button-link'>
                  <ListItemButton onClick={this.handleDrawerClose}>
                    <ListItemText primary={group.label} primaryTypographyProps={{variant: 'h6', style: headerStyle}} />
                  </ListItemButton>
                </NavLink>
                <Divider />
              </React.Fragment>
            )}
            {!site.disable_balance_check &&
              <React.Fragment>
                <NavLink to='/balance' className='button-link'>
                  <ListItemButton onClick={this.handleDrawerClose}>
                    <ListItemText primary={intl.formatMessage({id: "navigation.check_balance", defaultMessage: "Check Balance"})}
                                  primaryTypographyProps={{variant: 'h6', style: headerStyle}} />
                  </ListItemButton>
                </NavLink>
                <Divider />
              </React.Fragment>
            }
            {site.locales.length > 1 &&
              <React.Fragment>
                <ListItem aria-haspopup="true" aria-expanded={this.state.localeMenuOpen ? 'true' : undefined} onClick={this.handleLocaleMenuClick}>
                  <img className="locale-image" src={`/locales/${locale}.jpg`} alt={locale} />
                  <ListItemText primary={intl.formatMessage({id: localeTitle(locale), defaultMessage: locale})}
                                primaryTypographyProps={{variant: 'h6', style: headerStyle}} />
                </ListItem>
                <Menu anchorEl={this.localeMenuAnchor} open={this.state.localeMenuOpen} onClose={() => this.setState({localeMenuOpen: false})}>
                  {availableLocales(site.locales).map(locale => (
                    <MenuItem key={locale.locale} value={locale.locale} onClick={() => this.handleLocaleChange(locale.locale)}>
                      <img className="locale-image" src={`/locales/${locale.locale}.jpg`} alt={locale.locale} />
                      <FormattedMessage id={localeTitle(locale.locale)} defaultMessage={locale.locale}/>
                    </MenuItem>
                  ))}
                </Menu>
                <Divider />
              </React.Fragment>
            }
          </List>
        </Drawer>
      </React.Fragment>
    )
  }
}

export default injectIntl(Header);
